import { breadcrumbs } from 'constants/breadcrumbs'
import { Badge, Typography } from '@frontend/design_system'
import { useAppSelector } from 'redux/hooks'
import { isOperatorSelector } from 'redux/login/selectors'
import { MENU_NAMES } from 'texts/menuNames'
import { Container } from 'ui/molecules/Container'
import { AGREEMENTS, DOCUMENT_LIST } from 'texts/agreements'
import { useInitDocuments } from './hooks/useInitDocuments'
import { DocumentsControls } from 'ui/components/DocumentsControl'
import { DocumentType } from 'api/documents/types'
import styles from './styles.module.scss'

export const DocumentsList = () => {
  const isOperator = useAppSelector(isOperatorSelector)

  const { documents, onReload, loading } = useInitDocuments()

  const emptyDocuments = Object.keys(documents).filter(
    (key) => documents[key as keyof typeof documents].actual.files.length === 0
  )

  return (
    <>
      <Container
        title={MENU_NAMES.DOCUMENTS}
        breadcrumbList={isOperator ? [breadcrumbs.profileList] : []}
        currentPageLabel={MENU_NAMES.BOOKING_HISTORY}
        withNavigation={isOperator}
        loading={loading}
      >
        {!isOperator && !!emptyDocuments.length && (
          <Badge
            message={
              <Typography Tag="ul" name="body2WMedium" color="yellow800">
                {AGREEMENTS.DESCRIPTION}
                {emptyDocuments.map((documentType) => (
                  <Typography
                    Tag="li"
                    color="yellow800"
                    name="body2WMedium"
                    key={documentType}
                  >
                    {DOCUMENT_LIST[documentType]}
                  </Typography>
                ))}
              </Typography>
            }
            type="warning"
            className={styles.badge}
          />
        )}
        <div className={styles['documents-controls']}>
          {Object.entries(documents).map(([documentType, documents]) => (
            <DocumentsControls
              key={documentType}
              documentType={documentType as keyof typeof DocumentType}
              documents={documents}
              onReload={onReload}
            />
          ))}
        </div>
      </Container>
    </>
  )
}
